import TrackingService from 'services/TrackingService';

export class VideoPagePinTrackingService extends TrackingService {
    constructor(timeout) {
        super(timeout);

        this.requireFiredStateOnTracking = false;

        this.actionName = {
            PIN_FORGOT: 'trackParentalControlsEnterPinForgetPin',
            PIN_CANCEL: 'trackParentalControlsCancel',
            PIN_VIEW: 'trackParentalControlsPromptView',
            PIN_OK: 'trackParentalControlsEnterPinOk',
            PIN_FAIL: 'trackParentalControlsEnterPinFail',
        };

        this.paramKey = {
            PIN_PROMPT_VIEW: 'parentalControlsPromptView',
            PIN_ENTER_OK: 'parentalControlsEnterPinOk',
            PIN_ENTER_FAIL: 'parentalControlsEnterPinFailed',
            PIN_ENTER_FORGET: 'parentalControlsEnterPinForgetPin',
        };
    }

    /**
     * Send a "Pin Forgot" action to the tracking service.
     */
    pinForgot() {
        this.trackAction(this.actionName.PIN_FORGOT, {
            [this.paramKey.PIN_ENTER_FORGET]: '1',
        });
    }

    /**
     * Send a "Pin Canceled" action to the tracking service.
     */
    pinCancel() {
        this.trackAction(this.actionName.PIN_CANCEL, {});
    }

    /**
     * Send a "Pin View" action to the tracking service.
     */
    pinView() {
        this.trackAction(this.actionName.PIN_VIEW, {
            [this.paramKey.PIN_PROMPT_VIEW]: '1',
        });
    }

    /**
     * Send a "Pin Ok" action to the tracking service.
     */
    pinOk() {
        this.trackAction(this.actionName.PIN_OK, {
            [this.paramKey.PIN_ENTER_OK]: '1',
        });
    }

    /**
     * Send a "Pin Failed" action to the tracking service.
     */
    pinFail() {
        this.trackAction(this.actionName.PIN_FAIL, {
            [this.paramKey.PIN_ENTER_FAIL]: '1',
        });
    }
}
